import {
  Box,
  Button,
  chakra,
  FormControl,
  FormLabel,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
} from '@chakra-ui/react';
import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import { yoogaPNG } from 'assets/images';
import { useGlobalContext } from 'GlobalContext';
import { useCallback, useState } from 'react';
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authenticate, authenticateWithGoogle } from 'services/auth';
import { setStorageItem } from 'services/localStorage';

let enableLegacyLogin = false;

if (
  window.location.hostname === 'localhost' ||
  window.location.hostname.includes('develop')
) {
  enableLegacyLogin = true;
}

const Form = () => {
  const navigate = useNavigate();
  const { setLoggedUser } = useGlobalContext();

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const submit: React.FormEventHandler<HTMLFormElement> = useCallback(
    (e) => {
      e.preventDefault();
      setLoading(true);
      authenticate({ username, password })
        .then((response) => {
          setStorageItem('token', response.data.token);
          setStorageItem('user', JSON.stringify(response.data.user));
          setLoggedUser(response.data.user);
          navigate('/');
        })
        .catch(() => toast.error('Usuário ou senha incorretos'))
        .finally(() => setLoading(false));
    },
    [username, password, navigate, setLoggedUser],
  );

  const handleGoogleLogin = useCallback(
    (credentialResponse: CredentialResponse) => {
      if (!credentialResponse.credential) {
        toast.error('Erro ao obter credenciais do Google');
        return;
      }

      authenticateWithGoogle({ idToken: credentialResponse.credential })
        .then((response) => {
          setStorageItem('token', response.data.token);
          setStorageItem('user', JSON.stringify(response.data.user));
          setLoggedUser(response.data.user);
          navigate('/');
        })
        .catch(() => toast.error('Erro ao fazer login com Google'));
    },
    [navigate, setLoggedUser],
  );

  return (
    <Stack w="100%" h="100%" align="stretch" justify="center" p="4rem">
      <Stack align="center">
        <Image src={yoogaPNG} w="50%" />
      </Stack>
      {enableLegacyLogin && (
        <chakra.form
          onSubmit={submit}
          display="flex"
          alignItems="center"
          flexDirection="column"
          gap="1rem"
        >
          <FormControl maxW="360px">
            <FormLabel>Usuário</FormLabel>
            <Input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </FormControl>

          <FormControl maxW="360px">
            <FormLabel>Senha</FormLabel>
            <InputGroup>
              <Input
                pr="4.5rem"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement width="4.5rem">
                <IconButton
                  variant="ghost"
                  size="sm"
                  icon={showPassword ? <IoEye /> : <IoEyeOff />}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  onClick={() => setShowPassword(!showPassword)}
                />
              </InputRightElement>
            </InputGroup>
          </FormControl>

          <Button
            type="submit"
            isLoading={loading}
            variant="filled"
            w="100%"
            maxW="360px"
          >
            Entrar
          </Button>
        </chakra.form>
      )}

      <Box w="100%" maxW="360px" display="flex" alignSelf="center">
        <GoogleLogin
          onSuccess={handleGoogleLogin}
          onError={() => toast.error('Erro ao fazer login com Google')}
          text="signin_with"
          shape="rectangular"
          width="360"
        />
      </Box>
    </Stack>
  );
};

export default Form;
